// Navarra keeps its own land registry (not part of the national Catastro), so
// the national link finds nothing for its references. Navarra references are
// "31" + 16 digits + 2 letters; those links go through the CRM, which looks the
// parcel up live on catastro.navarra.es at every click and redirects there.
const NAVARRA_REF = /^31\d{16}[A-Z]{2}$/;

export const catastroUrl = (rawRef, apiBase) => {
  const ref = (rawRef || "").replace(/\s+/g, "").toUpperCase();
  if (NAVARRA_REF.test(ref)) return `${apiBase}/cadastre-res022/navarra-link/${ref}`;
  const q = encodeURIComponent(ref);
  return `https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?refcat=${q}&from=OVCBusqueda&pest=rc&final=&RCCompleta=${q}&ZV=NO&ZR=NO`;
};
